import App from "../../../services/App/App.js";

export default {
  /*** property ***/

  InputSelectKey: App.Enum.Input.Select.Key
}